import { render } from "./FeatureTable.vue?vue&type=template&id=69dfe976&scoped=true"
import script from "./FeatureTable.vue?vue&type=script&lang=js"
export * from "./FeatureTable.vue?vue&type=script&lang=js"

import "./FeatureTable.vue?vue&type=style&index=0&id=69dfe976&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69dfe976"]])

export default __exports__